import styled from "@emotion/styled";
import { List } from "atoms";
import { UserCard } from "features/profile/components/UserCard";
import { useArtistFollowers } from "../api/useFollowers";

type ArtistFollowersProps = {
  artistId: string;
};
/**
 *
 * Returns a list of an artists followers
 */
function ArtistFollowers({ artistId }: ArtistFollowersProps) {
  const { data } = useArtistFollowers(artistId || "");

  return (
    <FollowersList type="blank">
      {data?.data?.map((user) => (
        <Li key={user.id}>
          <UserCard user={user} />
        </Li>
      ))}
    </FollowersList>
  );
}

const FollowersList = styled(List)(({ theme }) => ({
  padding: "3rem 0 6rem",
  display: "grid",
  gap: theme.spacing.gap,
  gridTemplateColumns: "100%",
  "@media (min-width: 680px)": {
    gridTemplateColumns: `repeat(auto-fill, minmax(min(280px, 50% - 1rem), 1fr))`,
  },
}));
const Li = styled.li(({ theme }) => ({
  display: "flex",
}));

export { ArtistFollowers };
